import React, { useEffect, useState } from 'react';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Row, Col, Form, Input, Image, Button, message } from 'antd';
import { Link } from 'react-router-dom';
import AuthImg from '../../assets/img/main-banner.png';
import { Folio3AIIcon, BackArrow } from 'assets/icons';
import { userRegistration } from 'api-services/authentication';
import { useNavigate } from 'react-router-v6';
import useLoading from 'hooks/use-loading';

import './scss/auth.scss';

import AuthService from 'api-services/auth-service';

const Register = () => {
  let planParam = '';
  const [submitted, setSubmitted] = useState(false);
  const { setLoading } = useLoading();

  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthService.isAuthenticated()) navigate('/');
    const queryParams = new URLSearchParams(window.location.search);
    planParam = queryParams.get('plan');
  }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const data = await userRegistration(values, planParam);

      if (data?.status === 204) {
        message.success('Link has been sent to your email');
        setSubmitted(true);
        navigate('/thank-you/');
      } else if (data?.code === 'ERR_BAD_REQUEST' || data?.status === 409) {
        message.error(data.response.data.message);
      } else {
        showError(data?.response?.data?.errors);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const showError = (errors) => {
    for (const key in errors) {
      form.setFields([
        {
          name: key,
          errors: [errors[key]],
        },
      ]);
    }
  };

  return (
    <Row className='auth-container'>
      <Col span={10} className='auth-form-container'>
        <div>
          <a href='/' target='_blank' title='Chat Buddy Pro'>
            <Folio3AIIcon />
          </a>
          <h2>Register</h2>
          <Form id='register' form={form} size='large' name='horizontal_login' layout='vertical' onFinish={onFinish}>
            {!submitted ? (
              <>
                <Form.Item
                  label='First Name'
                  name='firstName'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please input first name!',
                    },
                  ]}>
                  <Input prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Enter First Name' />
                </Form.Item>
                <Form.Item
                  label='Last Name'
                  name='lastName'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please input your last name',
                    },
                  ]}>
                  <Input prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Enter Last Name' />
                </Form.Item>
                <Form.Item
                  label='Email Address'
                  name='email'
                  rules={[
                    {
                      type: 'email',
                      required: true,
                      message: 'Please input your email address!',
                    },
                  ]}>
                  <Input prefix={<UserOutlined className='site-form-item-icon' />} placeholder='Enter Email Address' />
                </Form.Item>
                <Form.Item
                  label='Password'
                  name='password'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      min: 6,
                      message: 'Please input password having 6 character long',
                    },
                  ]}>
                  <Input
                    prefix={<LockOutlined className='site-form-item-icon' />}
                    type='password'
                    placeholder='Password'
                  />
                </Form.Item>
                <Form.Item shouldUpdate className='action-btn'>
                  {() => (
                    <Button
                      type='primary'
                      htmlType='submit'
                      disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}>
                      Register
                    </Button>
                  )}
                </Form.Item>
              </>
            ) : (
              <>
                <p>An email has been sent to you for account activation.</p>

              </>
            )}
            <Form.Item className='action-btn'>
              <Link to={'/login'}>
                <Button type='light' className='d-center'>
                  <BackArrow />
                  Back to Login
                </Button>
              </Link>
            </Form.Item>
          </Form>
        </div>
      </Col>
      <Col span={14} className='auth-cover'>
        <div>
          <Image preview={false} src={AuthImg} />
        </div>
      </Col>
    </Row>
  );
};

export default Register;
